"use strict";

exports.__esModule = true;
exports.LayoutThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _ElementThumbnail = require("../ElementThumbnail");
var _Core = require("../../Core");
var _excluded = ["config", "width", "height", "widgets"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function createStateFromProps(_ref) {
  var widgets = _ref.widgets;
  var components = {};
  for (var i = 0; i < widgets.length; i++) {
    var widget = widgets[i];
    if (widget.components.Thumbnail) {
      components[widget.name] = widget.components.Thumbnail;
    }
  }
  return {
    components: components
  };
}

/**
 * Renders a thumbnail for a layout based on a configuration object and a list of
 * of widgets.
 */
var LayoutThumbnail = exports.LayoutThumbnail = /*#__PURE__*/function (_Component) {
  function LayoutThumbnail() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = createStateFromProps(_this.props);
    return _this;
  }
  _inheritsLoose(LayoutThumbnail, _Component);
  var _proto = LayoutThumbnail.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      config = _this$props.config;
    return nextProps.width !== width || nextProps.height !== height || !(0, _reactFastCompare["default"])(nextProps.config.element, config.element);
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      config = _this$props2.config,
      width = _this$props2.width,
      height = _this$props2.height,
      _widgets = _this$props2.widgets,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    var components = this.state.components;
    return /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_ElementThumbnail.ElementThumbnail, _extends({
      width: width,
      height: height,
      components: components,
      config: config.element
    }, extra)));
  };
  return LayoutThumbnail;
}(_react.Component);